export const FETCH_PEAK_TODAY_REQUEST = '[PeakToday] FETCH_PEAK_TODAY_REQUEST';
export const FETCH_PEAK_TODAY_SUCCESS = '[PeakToday] FETCH_PEAK_TODAY_SUCCESS';
export const FETCH_PEAK_TODAY_FAILURE = '[PeakToday] FETCH_PEAK_TODAY_FAILURE';
